import React from "react";
import { XCircle } from "lucide-react";
import { Button } from "./ui/button";

export const PaymentCancel = ({ onBack }) => {
  const urlParams = new URLSearchParams(window.location.search);
  const orderId = urlParams.get("order_id");

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <div className="max-w-md w-full text-center space-y-6">
        <div className="w-20 h-20 bg-amber-500/20 rounded-full flex items-center justify-center mx-auto">
          <XCircle className="w-12 h-12 text-amber-500" />
        </div>
        
        <h2 className="text-2xl font-bold text-white">Paiement annulé</h2>
        
        <p className="text-muted-foreground">
          Votre paiement a été annulé. Aucun montant n'a été débité de votre compte.
        </p>

        {orderId && (
          <p className="text-sm text-muted-foreground">
            Votre commande #{orderId.slice(0, 8)} est toujours en attente.
          </p>
        )}

        <div className="flex flex-col gap-3 pt-4">
          <Button
            onClick={() => window.history.back()}
            className="w-full"
          >
            Réessayer le paiement
          </Button>
          
          <Button
            variant="outline"
            onClick={() => window.location.href = "/"}
            className="w-full"
          >
            Retour à l'accueil
          </Button>
        </div>
      </div>
    </div>
  );
};
